import { Link, useNavigate } from "react-router-dom";
import NoData from "../../assets/img/nodata_green.svg"
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useEffect, useState } from "react";
import { formatDate } from "../../helpers/commons";
import { selectAccessToken, selectNtumaAccount } from "../../features/auth/authSlice";
import AppSpinner from "../elements/AppSpinner";
import { APP_STATUS, BASE_URL, COLLECTION_STATUS } from "../../helpers/constants";
import { fetchCollections, resetCursorCollections, selectCollections } from "../../features/transactions/collectionsSlice";
import useApiRequest from "../../helpers/api_request";
import { AxiosError } from "axios";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
const CollectionsPage = () => {
  const dispatch = useAppDispatch()
  const collections = useAppSelector(selectCollections)
  const ntumaAccount = useAppSelector(selectNtumaAccount);
  const loadingCollectionStatus = useAppSelector(state => state.collections.loadingCollectionStatus)
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useAppSelector(state => state.collections.totalPages)
  const apiRequest = useApiRequest()
  const accessToken = useAppSelector(selectAccessToken)
  const [downloadingCollections, setDownloadingCollections] = useState(false)

  useEffect(() => {
    dispatch(resetCursorCollections())
    dispatch(fetchCollections())
  }, [ntumaAccount])

  const today = ''

  const [startDate, setStartDate] = useState(today)
  const [endDate, setEndDate] = useState(today)
  const [downloading, setDownloading] = useState(false)

  const handleDownload = () => {
    
    downloadCollections(startDate, endDate)
  }

 // const downloadCollections = () => {

const downloadCollections = (start: string, end: string) => {

   if (start && end) {
      const startTime = new Date(start).getTime()
      const endTime = new Date(end).getTime()

      if (startTime > endTime) {
        toast.error("'Start Date' cannot be less greater than the 'End Date'.")
        return
      }
    }

    
    setDownloadingCollections(true)
    const toastLoader = toast.loading('Processing')
    apiRequest({
      method: 'get',
    //  url: BASE_URL + "/api/collections/download",
       url:
        BASE_URL +
        '/api/collections/download?startDate=' +
        start +
        '&endDate=' +
        end,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob'
    }).then((res) => {
      toast.dismiss(toastLoader)
      const url = URL.createObjectURL(new Blob([res], {
        type: 'application/vnd.ms-excel'
      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', "Collections Received.xlsx")
      document.body.appendChild(link)
      link.click()
      setDownloadingCollections(false)
    }).catch((error) => {
      toast.dismiss(toastLoader)
      const errorResponse = error as AxiosError;
      if (errorResponse.response) {
        const data = errorResponse.response.data as { message: string, status: string };
        dispatch(showToastMessage({
          message: data.message,
          type: "error",
          position: toast.POSITION.TOP_RIGHT
        }));
      } else {
        dispatch(showToastMessage({
          message: "Something went wrong",
          type: "error",
          position: toast.POSITION.TOP_RIGHT
        }));
      }
      setDownloadingCollections(false)
    })
  }

  return (
    <div>
      <div className="card mb-12">

        <div className="card-body flex flex-col px-4 py-4 min-h-half-screen pb-16">
          <div className="flex">
            <nav className="flex justify-between " aria-label="Breadcrumb">
              <ol className="inline-flex items-center mb-3 sm:mb-0">
                <li>
                  <div className="flex items-center">
                    <h5 className=" card-title ">Collections</h5>
                  </div>
                </li>

              </ol>
            </nav>
            <div className="flex-grow flex justify-end">
              {/*
              <DownloadButton callBack={() => downloadCollections()} isLoading={downloadingCollections} />
              */}
              

              <div className='flex items-center gap-1'>
                <div className='w-16 leading-4'>
                  <span className='text-gray-600 text-[13px]'>
                    Download
                    <br /> From:
                  </span>
                </div>
                <input
                  type='date'
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  className='border border-gray-300 py-1 px-2 h-10 rounded text-gray-500 text-sm focus:outline-none -mt-1'
                />

                <span className='text-gray-600 text-sm -mt-1'>To:</span>

                <input
                  type='date'
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  className='border border-gray-300 py-1 px-2 h-10 rounded text-gray-500 text-sm focus:outline-none -mt-1'
                />

                <DownloadButton
                  callBack={handleDownload}
                  isLoading={downloading}
                />
              </div>



              
            </div>
          </div>
          {
            (collections.length === 0 && loadingCollectionStatus != APP_STATUS.PENDING) &&
            <div className=" h-fit flex-grow flex flex-col justify-center ">
              <div className="flex justify-center">
                <div>
                  <img className=" w-32" src={NoData} alt="" />
                  <p>No Collections Yet!</p>
                </div>
              </div>
            </div>
          }
          {
            (collections.length > 0) &&
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead>
                <tr>
                  <th scope="col" >
                    Date
                  </th>
                  <th scope="col" >
                    Phone/Card
                  </th>
                  <th scope="col" >
                    Names
                  </th>
                  <th scope="col" >
                    Amount
                  </th>
                  <th scope="col" >
                    Channel
                  </th>
                  <th scope="col" >
                    Transaction ID
                  </th>
                  <th scope="col" >
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  collections.map((item, key) =>
                    <tr key={key}>
                      <td>
                        {formatDate(item.created_at, "MMM DD, YYYY H:mm")}

                      </td>
                      <td> {item.msisdn} {item.msisdn === null && "N/A"}
                      </td>
                      <td>
                        {(item.customer) ? item.customer.names ? item.customer.names : "n/a" : "n/a"}
                      </td>
                      <td>{item.currency} {item.amount.toLocaleString()}</td>
                      <td>{item.collection_channel} {item.msisdn === null && "Card"} </td>

                      {/* <td>{item.amount.toLocaleString()}</td>
                      <td>{item.msisdn_carrier} {item.msisdn === null && "Card"} </td> */}
                      <td>
                        {item.transaction_id}
                      </td>
                      <td>
                        {item.status === COLLECTION_STATUS.SUCCESSFUL &&
                          <span className="badge-success">{item.status}</span>}
                        {item.status === COLLECTION_STATUS.FAILED &&
                          <span className="badge-failed">{item.status}</span>}
                        {item.status === COLLECTION_STATUS.PENDING &&
                          <span className="badge-pending">{item.status}</span>}
                      </td>

                    </tr>
                  )
                }
              </tbody>
            </table>
          }

          {(loadingCollectionStatus === APP_STATUS.PENDING) && <AppSpinner />}
          {
            (currentPage < totalPages) &&
            <div className=" flex justify-center mt-16">
              <button onClick={() => {
                setCurrentPage(currentPage + 1)
                dispatch(fetchCollections())
              }} type="button" className="btn-light text-gray-600 ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" className=" text-gray-600" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 16h5v5M10 8H5V3m14.418 6.003A8 8 0 0 0 5.086 7.976m-.504 7.021a8 8 0 0 0 14.331 1.027" /></svg>
                <span className="pl-1">Load More</span>
              </button>
            </div>
          }




        </div>
      </div>

    </div>
  )
}
export default CollectionsPage;

export const DownloadButton = ({ isLoading, callBack }: { isLoading: boolean, callBack: () => void }) => {
  return (
    <>
      <button onClick={() => callBack()} type="button" className=" btn-light mb-2">
        {!isLoading ?
          <div className=" flex">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className=" text-gray-600" viewBox="0 0 24 24"><path fill="currentColor" d="M6.5 20q-2.275 0-3.887-1.575Q1 16.85 1 14.575q0-1.95 1.175-3.475Q3.35 9.575 5.25 9.15q.425-1.8 2.125-3.425Q9.075 4.1 11 4.1q.825 0 1.413.587Q13 5.275 13 6.1v6.05l.9-.875q.275-.275.688-.275q.412 0 .712.3q.275.275.275.7q0 .425-.275.7l-2.6 2.6q-.15.15-.325.212q-.175.063-.375.063t-.375-.063q-.175-.062-.325-.212l-2.6-2.6q-.275-.275-.287-.688Q8.4 11.6 8.7 11.3q.275-.275.687-.288q.413-.012.713.263l.9.875V6.1q-1.9.35-2.95 1.837Q7 9.425 7 11h-.5q-1.45 0-2.475 1.025Q3 13.05 3 14.5q0 1.45 1.025 2.475Q5.05 18 6.5 18h12q1.05 0 1.775-.725Q21 16.55 21 15.5q0-1.05-.725-1.775Q19.55 13 18.5 13H17v-2q0-1.2-.55-2.238Q15.9 7.725 15 7V4.675q1.85.875 2.925 2.588Q19 8.975 19 11q1.725.2 2.863 1.487Q23 13.775 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20Zm5.5-8.95Z" /></svg>
            <span className=" pl-[2px] text-gray-600 text-sm">Download</span>
          </div> :
          <div className="flex justify-center">
            <div role="status">
              <svg aria-hidden="true" className="inline w-3 h-3 mr-2 text-gray-100 animate-spin fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
            Please wait
          </div>
        }
      </button>
    </>
  )
}
